/**
 * 
 * @param {Array} data 数组, 可以是数字数组, 也可以是对象数组
 * @param {key: string | symbol, isDesc: Boolean} options 如果数据是对象数组需要提供键名, isDesc是否为降序默认为true
 */
export const sort = (data, options = {}) => {
  const { key = "", isDesc = true } = options;
  let res = [...data];
  res.sort((a, b) => {
    if (typeof a === "number" || !isNaN(Number(a))) {
      if (isDesc) {
        return b - a;
      }
      return a - b;
    }
    if(isDesc){
      return b[key] - a[key];
    }
    return a[key] - b[key];
  })
  return res;
}